import React from "react";
import { Mail, MapPin, Info } from "lucide-react";
import LegalShell, { LegalSection } from "@/components/LegalShell";

// ============================================================================
// /contact — public contact page (no login required).
// C1 — Contact Us Page. Single canonical email + business mailing address,
// no contact form (avoids spam, backend mail handling, and validation
// complexity for now — mailto: link only).
// ============================================================================
const CONTACT_EMAIL = "rigsentinel@gmail.com";

const ADDRESS_LINES = [
  "180 Mill Street",
  "Toronto, ON M4M 0V8",
  "Canada",
];

export default function Contact() {
  return (
    <LegalShell
      title="Contact RigSentinel"
      subtitle="For support, billing questions, account help, or general inquiries, contact the RigSentinel team."
      lastUpdated="February 2026"
      testId="page-contact"
    >
      <LegalSection id="email" title="Email">
        <div
          data-testid="contact-email-card"
          className="rounded-md border p-3 flex items-start gap-3"
          style={{
            borderColor: "var(--rs-border)",
            background: "rgba(22,24,29,0.55)",
          }}
        >
          <Mail
            className="w-4 h-4 mt-0.5 shrink-0"
            style={{ color: "var(--rs-amber)" }}
          />
          <div className="flex-1 min-w-0">
            <div className="label-up text-[10px] text-[var(--rs-text-3)] mb-0.5">
              Email the RigSentinel team
            </div>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-sm font-semibold underline break-all"
              style={{ color: "var(--rs-amber)" }}
              data-testid="contact-email-link"
            >
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
      </LegalSection>

      <LegalSection id="address" title="Business / mailing address">
        <div
          data-testid="contact-address-card"
          className="rounded-md border p-3 flex items-start gap-3"
          style={{
            borderColor: "var(--rs-border)",
            background: "rgba(22,24,29,0.55)",
          }}
        >
          <MapPin
            className="w-4 h-4 mt-0.5 shrink-0"
            style={{ color: "var(--rs-amber)" }}
          />
          <div className="flex-1 min-w-0">
            <div className="label-up text-[10px] text-[var(--rs-text-3)] mb-0.5">
              RigSentinel
            </div>
            <address
              data-testid="contact-address-block"
              className="not-italic text-sm leading-relaxed text-[var(--rs-text)]"
            >
              {ADDRESS_LINES.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </address>
          </div>
        </div>
      </LegalSection>

      <LegalSection id="support-note" title="When you email">
        <div
          data-testid="contact-support-note"
          className="flex items-start gap-2"
        >
          <Info
            className="w-4 h-4 mt-0.5 shrink-0"
            style={{ color: "var(--rs-amber)" }}
          />
          <p>
            Please include your account email and a short description of the
            issue when contacting support.
          </p>
        </div>
      </LegalSection>
    </LegalShell>
  );
}
